/** Ruta absoluta a un asset en /public (no usable en CSS importado por webpack). */
export function publicAsset(path) {
  if (!path) return ''
  const base = process.env.PUBLIC_URL || ''
  const normalized = path.startsWith('/') ? path : `/${path}`
  return `${base}${normalized}`
}

/**
 * URL del banner de un Han en /public/han/{slug}.jpg
 */
export function hanBannerSrc(slug) {
  if (!slug) return null
  const base = process.env.PUBLIC_URL || ''
  return `${base}/han/${encodeURIComponent(slug)}.jpg`
}

/**
 * Comprueba si existe banner para el slug (precarga en cliente).
 */
export function probeHanBanner(slug) {
  const src = hanBannerSrc(slug)
  if (!src) return Promise.resolve(null)

  return new Promise((resolve) => {
    const img = new Image()
    img.onload = () => resolve(src)
    img.onerror = () => resolve(null)
    img.src = src
  })
}
